<div class="conflict-detection">
  <p class="subtitle">{{ 'i18n.domain.product-template.publishing-wizard.resolve-conflicts' | translate }}</p>

  <div class="conflicts-list">
    <div *ngFor="let templateId of selectedTemplateIds" class="conflict-item">
      <div *ngIf="hasConflict(templateId)" class="conflict-warning">
        <span class="warning-icon">⚠️</span>
        <span class="warning-text">{{ 'i18n.domain.product-template.publishing-wizard.conflict-detected' | translate }}</span>
      </div>
      <div *ngIf="!hasConflict(templateId)" class="no-conflict-info">
        <span class="info-icon">✓</span>
        <span class="info-text">{{ 'i18n.domain.product-template.publishing-wizard.no-conflicts' | translate }}</span>
      </div>

      <div class="resolution-options">
        <label class="option">
          <input type="radio" [value]="ConflictResolutionOption.CreateNew" [checked]="getResolution(templateId) === ConflictResolutionOption.CreateNew" (change)="setResolution(templateId, ConflictResolutionOption.CreateNew)">
          <span>{{ 'i18n.domain.product-template.publishing-wizard.publish-new' | translate }}</span>
        </label>
        <label class="option" *ngIf="hasConflict(templateId)">
          <input type="radio" [value]="ConflictResolutionOption.UpdateExisting" [checked]="getResolution(templateId) === ConflictResolutionOption.UpdateExisting" (change)="setResolution(templateId, ConflictResolutionOption.UpdateExisting)">
          <span>{{ 'i18n.domain.product-template.publishing-wizard.update-existing' | translate }}</span>
        </label>
      </div>

      <div class="product-details" *ngIf="hasConflict(templateId)">
        <h4>{{ 'i18n.domain.product-template.publishing-wizard.product-details' | translate }}</h4>
        <div class="details-grid">
          <div class="detail-field">
            <label>{{ 'i18n.domain.product-template.publishing-wizard.template-name' | translate }}:</label>
            <input type="text" readonly [value]="getConflict(templateId)?.templateName || ''">
          </div>
          <div class="detail-field">
            <label>{{ 'i18n.domain.product-template.publishing-wizard.existing-product' | translate }}:</label>
            <input type="text" readonly [value]="getConflict(templateId)?.existingProductName || ''">
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="action-buttons">
    <p-button label="{{ 'i18n.domain.product-template.publishing-wizard.next-review' | translate }}" icon="pi pi-arrow-right" (onClick)="proceed()" [disabled]="!canProceed()"></p-button>
  </div>
</div>
